import { createAction, props } from '@ngrx/store';
import type { AdMessage } from './ads.model';

export const adMessageReceived = createAction(
  '[Message EventListener] Received Ad Message',
  props<{ payload: { key: string; message: AdMessage } }>()
);
